import React from 'react';
import styled from 'styled-components';
import * as BuilderUI from '../../../../../../components/Builder/BuilderUI';
import SignificanceExperimentId from './SignificanceExperimentId';
import { useAppSelector } from '../../../../../../redux/hooks';
import { significanceCriteriaSelector } from '../../../../../../redux/selectors/builder';
import { assertCondition } from '../../../../../../utils/types';
import { SignificanceModeKey } from '../../../../../../utils/apollo/graphqlSchema';
import SignificanceExperimentControlGroup from './SignificanceExperimentControlGroup';
import SignificanceExperimentVariants from './SignificanceExperimentVariants';

const Row = styled.div`
  display: grid;
  grid-template-columns: 90px 1fr;
  grid-column-gap: 8px;
`;

const FirstRow = styled(Row)`
  grid-template-columns: 90px 240px;
`;

const Label = styled(BuilderUI.InputLabel)`
  align-self: start;
  margin-top: 7px;
  text-align: right;
`;

const DividerRow = styled(Row)`
  margin-top: 12px;
  margin-bottom: 12px;
`;

const ControlRow = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 16px;
`;

const SignificanceExperimentCriteria = () => {
  const significanceCriteria = useAppSelector(significanceCriteriaSelector);
  assertCondition(
    significanceCriteria?.modeKey === SignificanceModeKey.Experiment,
  );
  const { experimentId } = significanceCriteria;

  return (
    <>
      <FirstRow>
        <Label>Experiment ID</Label>
        <SignificanceExperimentId />
      </FirstRow>
      {experimentId && (
        <>
          <DividerRow>
            <div />
            <BuilderUI.HorizontalDivider />
          </DividerRow>
          <Row>
            <Label>Control</Label>
            <ControlRow>
              <SignificanceExperimentControlGroup />
              <SignificanceExperimentVariants />
            </ControlRow>
          </Row>
        </>
      )}
    </>
  );
};

export default SignificanceExperimentCriteria;
